/**
 * Configuration for AI model selection and authentication
 */
export interface ModelConfig {
  /**
   * The AI model provider to use
   * Defaults to "gemini" if not specified
   */
  model?: "gemini" | "claude" | "groq";
  
  /**
   * API key for the selected model
   * If not provided, falls back to environment variables
   */
  apiKey?: string;
}

/**
 * Supported AI model providers
 */
export enum AIModelProvider {
  GEMINI = "gemini",
  CLAUDE = "claude",
  GROQ = "groq"
}

